import ascensionMedicalGroup from '@/assets/membership-card/ascension-medical-group.svg';
import ascensionSaintThomas from '@/assets/membership-card/ascension-saint-thomas.svg';
import memorialPrimaryCare from '@/assets/membership-card/memorial-primary-care.png';

/**
 * Salesforce's `Co_brand_Name__c` is free text, so two partners match on a substring while
 * Ascension Medical Group matches exactly — a longer name merely containing it is a different
 * practice and must not pick up this mark.
 */
const CO_BRAND_LOGOS: { match: (coBrandName: string) => boolean; src: string }[] = [
  { match: (name) => name.includes('Memorial Primary Care'), src: memorialPrimaryCare },
  { match: (name) => name.includes('Ascension Saint Thomas'), src: ascensionSaintThomas },
  { match: (name) => name === 'Ascension Medical Group', src: ascensionMedicalGroup },
];

/**
 * The partner logo artwork for a co-brand name, or null when there is none — an unset co-brand and
 * an unrecognized partner both fall back to the practice's card display name.
 */
export function resolveCoBrandLogo(coBrandName: string | null | undefined): string | null {
  if (!coBrandName) {
    return null;
  }
  return CO_BRAND_LOGOS.find(({ match }) => match(coBrandName))?.src ?? null;
}
